// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Kw-z","tooltipWrapper":"Lw-z","icon":"Mw-z","tooltip":"Nw-z","content":"Ow-z"};